const settings = {
    logo: "MéxPréstamos",
    logo_description: "Manera conveniente de obtener un préstamo en México.",
    footer_text: " - Conveniente selección de préstamos en México, 2020",
    title: "MéxPréstamos - Emisión de préstamos",
    loan_value: "50000",

    lending_url: "https://lk.dineromx.com/",
    lending_name: "Dineromx.com",

    favicon: "../logo/zaimko-small-logo.png",
    logo_img: "../logo/zaimko-small-logo.png",

    primary_color: "#3FB3E2",
    secondary_color: "#3FB3E2",
    anchor_color: "#2196F3",
    spinner_color: "#BDBDBD",

    gtm: "GTM-P6S8ZZ3",

    yandex_metrika: "56104465",

    is_phone_required: false,
    is_email_required: false,
    is_fio_required: true,
    is_passport_required: false,
    is_password_required: false,

    default_password : "cFe4pmdcocyGeT7SdCpQsyLVs",

    skip_3_step: false,

    is_mailgun_ok: false,
    show_i_need: true,

    show_slider: false,
    default_possibility: 15,
    min_default_possibility: 12,
    max_default_possibility: 20,
    default_loanvalue: 2000,
    min_default_loanvalue: 1000,
    max_default_loanvalue: 30000,
    step: 10000,

    show_additional_slogan: false,

    get_more_offers_verificate_your_email:
        "Obtenga aún más ofertas confirmadas su número de teléfono",

    contact_email: "",
    social_providers: [],

    enable_ads_reg: false,
    ads_reg_settings: {
        class: "",
        style: "",
        data_ad_client: "",
        data_ad_slot: "",
        data_ad_format: "",
        data_full_width_responsive: "",
    },

    enable_ads_offers: false,
    ads_offers_settings: {
        placement: "",
        class: "",
        style: "",
        data_ad_client: "",
        data_ad_slot: "",
        data_ad_format: "",
        data_ad_layout_key: "",
    },

    enable_second_ads_offers: false,
    second_ads_offers_settings: {
        class: "",
        style: "",
        data_ad_client: "",
        data_ad_slot: "",
        data_ad_format: "",
        data_full_width_responsive: "",
    },

    payments: {
        enabled: false,
        registration: false,
        pass_registration: false,
        offer: false,
        subscription_confirm: true,
        subscription_confirm_required: true,

        registration_possibility: "",
        registration_help_text: "",
        offer_help_text: "",
        after_check_requisites: false,
    },
};

export default settings;
